import { useCallback } from 'react';

import { useMutation } from '@apollo/client/react';

import { useWatermarkSkippedWarning } from './useWatermarkSkippedWarning';
import { COMPOSITE_WATERMARK_IMAGES } from './watermarkQueries';

export function useCompositeWatermarkImages() {
  const [compositeWatermarkImages, result] = useMutation(
    COMPOSITE_WATERMARK_IMAGES,
  );
  const { notifySkipped, snackbar } = useWatermarkSkippedWarning();

  const compositeImages = useCallback(
    async (
      lotId: string,
      { awaitRefetchQueries = false }: { awaitRefetchQueries?: boolean } = {},
    ) => {
      const { data } = await compositeWatermarkImages({
        variables: { lot_id: lotId },
        refetchQueries: ['GetPropertyImages'],
        awaitRefetchQueries,
      });
      notifySkipped(data?.composite_watermark_images?.skipped_count ?? 0);
    },
    [compositeWatermarkImages, notifySkipped],
  );

  return { compositeImages, ...result, snackbar };
}
